import { AppError, AppErrorOptions } from "./AppError.js";

export interface UnsupportedOption extends Partial<AppErrorOptions> {
    // container: HTMLElement;
}

export class Unsupported extends AppError {

    public create(options: UnsupportedOption): this {

        var browsers: { title_de: string; title_en: string; url_de: string; url_en: string; icon: string }[] = [
            {
                icon: "fab fa-firefox",
                title_de: "Firefox",
                title_en: "Firefox",
                url_de: "https://www.mozilla.org/de/firefox/new/",
                url_en: "https://www.mozilla.org/en/firefox/new/"
            },
            {
                icon: "fab fa-chrome",
                title_de: "Google Chrome",
                title_en: "Google Chrome",
                url_de: "https://www.google.com/intl/de_de/chrome/",
                url_en: "https://www.google.com/intl/en_us/chrome/"
            },
            {
                icon: "fab fa-edge",
                title_de: "Microsoft Edge Chromium",
                title_en: "Microsoft Edge Chromium",
                url_de: "https://www.microsoft.com/de-de/edge",
                url_en: "https://www.microsoft.com/en-us/edge"
            },
            {
                icon: "fab fa-safari",
                title_de: "Apple Safari",
                title_en: "Apple Safari",
                url_de: "https://support.apple.com/de_DE/downloads/safari",
                url_en: "https://support.apple.com/en_US/downloads/safari"
            }
        ];

        var de: string = "";
        var en: string = "";

        for (var icon of browsers) {
            de += `<a class="awi-app-error__browser ${icon.icon}" href="${icon.url_de}" title="${icon.title_de}" target="_blank"></a>`;
            en += `<a class="awi-app-error__browser ${icon.icon}" href="${icon.url_en}" title="${icon.title_en}" target="_blank"></a>`;
        }

        options = e5.object.merge({
            container: null,
            message: {
                type: "html",
                de: "Leider wird ihr Browser nicht unterstützt.<br>Bitte verwenden Sie einen aktuellen Browser:",
                en: "Unfortunately your browser is not supported<br>Please use an up-to-date browser:"
            },
            content: {
                type: "html",
                de: de,
                en: en
            }
        } as UnsupportedOption, options || {});

        super.create(options as AppErrorOptions);

        return this;
    }
}